import { Component, Input, OnChanges } from '@angular/core';

let SPARK_UID = 0;

@Component({
  selector: 'audit-sparkline',
  styles: [
    `
      .spark-wrap {
        position: relative;
        display: block;
        width: 100%;
      }
      .spark-svg {
        display: block;
        width: 100%;
        overflow: visible;
      }
      /* Rendered outside the stretched SVG so it stays a perfect circle */
      .spark-dot {
        position: absolute;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
      }
    `,
  ],
  template: `
    <span class="spark-wrap" *ngIf="linePath" [style.height.px]="height">
      <svg
        class="spark-svg"
        [attr.viewBox]="'0 0 ' + width + ' ' + height"
        [attr.height]="height"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient [attr.id]="gradId" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" [attr.stop-color]="color" stop-opacity="0.22"></stop>
            <stop offset="100%" [attr.stop-color]="color" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
        <path [attr.d]="areaPath" [attr.fill]="'url(#' + gradId + ')'" stroke="none"></path>
        <path
          [attr.d]="linePath"
          fill="none"
          [attr.stroke]="color"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          vector-effect="non-scaling-stroke"
        ></path>
      </svg>
      <span
        class="spark-dot"
        [style.left.%]="endXPct"
        [style.top.%]="endYPct"
        [style.background]="color"
      ></span>
    </span>
  `,
})
export class AuditSparklineComponent implements OnChanges {
  @Input() values: number[] = [];
  @Input() color = '#6161ff';
  @Input() width = 108;
  @Input() height = 32;

  gradId = 'spark' + ++SPARK_UID;
  linePath = '';
  areaPath = '';
  endXPct = 0;
  endYPct = 0;

  ngOnChanges(): void {
    const raw = (this.values || []).filter(
      (v) => v !== null && v !== undefined && !isNaN(v as any),
    ) as number[];

    if (raw.length < 2) {
      this.linePath = '';
      return;
    }

    const w = this.width;
    const h = this.height;
    const p = 4;
    const min = Math.min(...raw);
    const max = Math.max(...raw);
    const rng = max - min || 1;
    const X = (i: number) => p + (i * (w - 2 * p)) / (raw.length - 1);
    const Y = (v: number) => h - p - ((v - min) / rng) * (h - 2 * p);

    this.linePath = raw
      .map((v, i) => (i ? 'L' : 'M') + X(i).toFixed(1) + ' ' + Y(v).toFixed(1))
      .join(' ');
    this.areaPath =
      this.linePath +
      ` L ${X(raw.length - 1).toFixed(1)} ${h} L ${X(0).toFixed(1)} ${h} Z`;

    const endX = X(raw.length - 1);
    const endY = Y(raw[raw.length - 1]);
    this.endXPct = (endX / w) * 100;
    this.endYPct = (endY / h) * 100;
  }
}
